<template>
  <div class="gx-profile">
    <!-- <h1 class="gx-main__title">个人设置</h1> -->
    <!-- Tabs -->
    <div class="gx-profile__tabs">
      <button
        v-for="t in tabs"
        :key="t.id"
        class="gx-profile__tab"
        :class="{ 'gx-profile__tab--on': tab === t.id }"
        @click="tab = t.id"
      >
        {{ t.label }}
      </button>
    </div>

    <!-- ── Tab 1: 个人信息 ── -->
    <div v-if="tab === 'info'" class="gx-profile__max">
      <!-- 头像区 -->
      <div class="gx-profile__avatar-card">
        <div class="gx-profile__avatar-wrap">
          <div class="gx-profile__avatar">{{ avatarText }}</div>
          <div class="gx-profile__avatar-online">
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none"><circle cx="4" cy="4" r="3" fill="#fff" /></svg>
          </div>
        </div>
        <div>
          <div class="gx-profile__name">{{ userName }}</div>
          <div class="gx-profile__badges">
            <span class="gx-profile__badge gx-profile__badge--vip">{{ levelText }}</span>
            <span class="gx-profile__badge gx-profile__badge--online">● 在线</span>
          </div>
        </div>
      </div>

      <!-- 信息行 -->
      <div class="gx-profile__info-card">
        <div class="gx-profile__row">
          <div class="gx-profile__row-left">
            <span class="gx-profile__row-label">当前手机号：</span>
            <div class="gx-profile__row-value">
              <span class="gx-profile__mono">{{ phoneShow }}</span>
              <span class="gx-profile__verified">已验证</span>
            </div>
          </div>
        </div>
        <div class="gx-profile__row">
          <div class="gx-profile__row-left">
            <span class="gx-profile__row-label">登录密码：</span>
            <div class="gx-profile__row-value gx-profile__mono">***********</div>
          </div>
          <button class="gx-profile__btn-red" @click="showPwModal = true">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M9.5 1.5a2 2 0 012.8 2.8L4 12.6H1v-3L9.5 1.5z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" /></svg>
            修改密码
          </button>
        </div>
        <div class="gx-profile__tip">
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><circle cx="6.5" cy="6.5" r="6" stroke="#1677FF" stroke-width="1.1" /><path d="M6.5 5.5v3.5M6.5 4.5v.5" stroke="#1677FF" stroke-width="1.3" stroke-linecap="round" /></svg>
          <span>修改密码需要验证手机号，验证码将发送至绑定手机</span>
        </div>
      </div>
    </div>

    <!-- ── Tab 2: 桌面软件 ── -->
    <div v-if="tab === 'desktop'" class="gx-profile__max">
      <div class="gx-profile__soft-card">
        <div class="gx-profile__banner gx-profile__banner--red">
          <div class="gx-profile__banner-icon">💻</div>
          <div>
            <div class="gx-profile__banner-title">观星树桌面客户端</div>
            <div class="gx-profile__banner-sub">提供更流畅的操作体验和更多桌面专属功能</div>
          </div>
        </div>
        <div class="gx-profile__soft-body">
          <div class="gx-profile__soft-item">
            <div>
              <div class="gx-profile__soft-name">桌面端下载</div>
              <div class="gx-profile__soft-desc">Windows 10/11 · 64位 · 当前版本 v2.3.1</div>
            </div>
            <button class="gx-profile__download" @click="downloadZM">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1v8M4 7l3 3 3-3M1 11v1a1 1 0 001 1h10a1 1 0 001-1v-1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /></svg>
              下载软件
            </button>
          </div>
          <div class="gx-profile__soft-item">
            <div>
              <div class="gx-profile__soft-name">桌面端授权</div>
              <div class="gx-profile__soft-desc">获取授权码激活桌面客户端</div>
            </div>
            <div class="gx-profile__soft-actions">
              <span v-if="copied" class="gx-profile__copied">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6l2.5 2.5 6-6" stroke="#52C41A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                已复制
              </span>
              <button class="gx-profile__btn-red" :disabled="codeLoading" @click="getAuthCode">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1.5" y="1.5" width="7" height="9" rx="1.5" stroke="currentColor" stroke-width="1.2" /><path d="M4.5 4.5H11a1 1 0 011 1V12" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /></svg>
                {{ codeLoading ? '获取中...' : '获取授权code' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Tab 3: 插件软件 ── -->
    <div v-if="tab === 'plugin'" class="gx-profile__max">
      <div class="gx-profile__soft-card">
        <div class="gx-profile__banner gx-profile__banner--blue">
          <div class="gx-profile__banner-icon">🧩</div>
          <div>
            <div class="gx-profile__banner-title">观星树浏览器插件</div>
            <div class="gx-profile__banner-sub">Chrome/Edge 扩展程序，实现一键铺货和数据同步</div>
          </div>
        </div>
        <div class="gx-profile__soft-body">
          <div class="gx-profile__soft-item">
            <div>
              <div class="gx-profile__soft-name">观星树运营插件</div>
              <div class="gx-profile__soft-desc">下载插件安装包</div>
            </div>
            <button class="gx-profile__download" @click="downloadXinghaohuoOpsPlugin">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1v8M4 7l3 3 3-3M1 11v1a1 1 0 001 1h10a1 1 0 001-1v-1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /></svg>
              下载软件
            </button>
          </div>
          <div class="gx-profile__soft-item">
            <div>
              <div class="gx-profile__soft-name">星好货sku插件</div>
              <div class="gx-profile__soft-desc">下载插件安装包</div>
            </div>
            <button class="gx-profile__download" @click="downloadXinghaohuoSkuPlugin">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1v8M4 7l3 3 3-3M1 11v1a1 1 0 001 1h10a1 1 0 001-1v-1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /></svg>
              下载软件
            </button>
          </div>
          <div class="gx-profile__notice">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="6.5" stroke="#1677FF" stroke-width="1.1" /><path d="M7 5.5v4M7 4.5v.5" stroke="#1677FF" stroke-width="1.3" stroke-linecap="round" /></svg>
            <div class="gx-profile__notice-text">
              插件支持 Chrome 88+ 和 Edge 88+。安装后在插件管理页启用，并登录您的观星树账号绑定使用。
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 修改密码弹窗 -->
    <div v-if="showPwModal" class="gx-profile__modal" @click.self="showPwModal = false">
      <div class="gx-profile__modal-box">
        <div class="gx-profile__modal-head">
          <div class="gx-profile__modal-title-wrap">
            <span class="gx-profile__modal-bar"></span>
            <span class="gx-profile__modal-title">修改密码</span>
          </div>
          <button class="gx-profile__modal-close" @click="showPwModal = false">
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M1 1l9 9M10 1L1 10" stroke="#4A4A6A" stroke-width="1.4" stroke-linecap="round" /></svg>
          </button>
        </div>
        <div class="gx-profile__modal-body">
          <!-- 验证码 -->
          <div class="gx-profile__pw-field">
            <div class="gx-profile__pw-label-row">
              <span class="gx-profile__req">*</span>
              <label class="gx-profile__pw-label">验证码</label>
              <span class="gx-profile__pw-hint">— 发送至手机 {{ phoneShow }}</span>
            </div>
            <div class="gx-profile__pw-code-row">
              <input v-model="pwCode" class="gx-profile__pw-input gx-profile__pw-input--flex" placeholder="输入验证码" />
              <button class="gx-profile__btn-send" :disabled="pwCountdown > 0" @click="sendPwCode">
                {{ pwCountdown > 0 ? pwCountdown + 's 后重发' : '获取验证码' }}
              </button>
            </div>
          </div>

          <!-- 新密码 -->
          <div class="gx-profile__pw-field">
            <div class="gx-profile__pw-label-row">
              <span class="gx-profile__req">*</span>
              <label class="gx-profile__pw-label">新密码</label>
            </div>
            <div class="gx-profile__pw-input-wrap">
              <input v-model="newPwd" class="gx-profile__pw-input" :type="showNew ? 'text' : 'password'" placeholder="输入新密码" />
              <button class="gx-profile__pw-eye" @click="showNew = !showNew">
                <svg v-if="showNew" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M1 7.5C2.5 5 5 3 7.5 3s5 2 6.5 4.5C12.5 10 10 12 7.5 12S2.5 10 1 7.5z" stroke="currentColor" stroke-width="1.2" /><circle cx="7.5" cy="7.5" r="2" stroke="currentColor" stroke-width="1.2" /></svg>
                <svg v-else width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M1 7.5C2.5 5 5 3 7.5 3s5 2 6.5 4.5C12.5 10 10 12 7.5 12S2.5 10 1 7.5z" stroke="currentColor" stroke-width="1.2" /><path d="M2 2l11 11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" /></svg>
              </button>
            </div>
            <div v-if="newPwd" class="gx-profile__pw-strength">
              <div class="gx-profile__pw-bars">
                <div v-for="l in 3" :key="l" class="gx-profile__pw-bar" :style="{ background: l <= pwStrength ? strengthColor : '#f0f0f0' }"></div>
              </div>
              <span class="gx-profile__pw-strength-text" :style="{ color: strengthColor }">密码强度：{{ strengthLabel }}</span>
            </div>
          </div>

          <!-- 确认密码 -->
          <div class="gx-profile__pw-field">
            <div class="gx-profile__pw-label-row">
              <span class="gx-profile__req">*</span>
              <label class="gx-profile__pw-label">确认密码</label>
            </div>
            <div class="gx-profile__pw-input-wrap">
              <input v-model="confirmPwd" class="gx-profile__pw-input" :class="{ 'gx-profile__pw-input--err': pwMismatch }" :type="showConf ? 'text' : 'password'" placeholder="再次输入确认密码" />
              <button class="gx-profile__pw-eye" @click="showConf = !showConf">
                <svg v-if="showConf" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M1 7.5C2.5 5 5 3 7.5 3s5 2 6.5 4.5C12.5 10 10 12 7.5 12S2.5 10 1 7.5z" stroke="currentColor" stroke-width="1.2" /><circle cx="7.5" cy="7.5" r="2" stroke="currentColor" stroke-width="1.2" /></svg>
                <svg v-else width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M1 7.5C2.5 5 5 3 7.5 3s5 2 6.5 4.5C12.5 10 10 12 7.5 12S2.5 10 1 7.5z" stroke="currentColor" stroke-width="1.2" /><path d="M2 2l11 11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" /></svg>
              </button>
            </div>
            <div v-if="confirmPwd" class="gx-profile__pw-match">
              <template v-if="pwMatch">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="5.5" stroke="#52C41A" stroke-width="1.1" /><path d="M3.5 6.5l1.5 1.5 4-4" stroke="#52C41A" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" /></svg>
                <span style="color:#52C41A">密码匹配</span>
              </template>
              <template v-else>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="5.5" stroke="#E85D5D" stroke-width="1.1" /><path d="M4 4l4 4M8 4l-4 4" stroke="#E85D5D" stroke-width="1.3" stroke-linecap="round" /></svg>
                <span style="color:#E85D5D">两次密码不一致</span>
              </template>
            </div>
          </div>
        </div>
        <div class="gx-profile__modal-foot">
          <button class="gx-profile__modal-btn" @click="showPwModal = false">取消</button>
          <button class="gx-profile__modal-btn gx-profile__modal-btn--red" :disabled="!canSubmit" @click="changePwd">
            {{ pwdSubmitting ? '提交中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import common from '../../assets/js/utils/common'

export default {
  name: 'NewProfilePage',
  data() {
    return {
      tabs: [
        { id: 'info', label: '个人信息' },
        { id: 'desktop', label: '桌面软件' },
        { id: 'plugin', label: '插件软件' }
      ],
      tab: 'info',
      phone: '',
      phoneShow: '',
      showPwModal: false,
      pwCode: '',
      newPwd: '',
      confirmPwd: '',
      showNew: false,
      showConf: false,
      pwCountdown: 0,
      pwdSubmitting: false,
      copied: false,
      codeLoading: false,
      authCode: ''
    }
  },
  computed: {
    userName() {
      const u = this.$store.state.login.userinfo || {}
      return u.nickname || u.name || u.mobile || '未登录'
    },
    avatarText() {
      const name = this.userName
      return name && name !== '未登录' ? name[0] : '星'
    },
    levelText() {
      const level = this.$store.state.login.user_level
      if (level === 1) return '企业版会员'
      // if (level === 2) return '企业版会员'
      return '普通会员'
    },
    pwMatch() {
      return this.newPwd && this.confirmPwd && this.newPwd === this.confirmPwd
    },
    pwMismatch() {
      return this.newPwd && this.confirmPwd && this.newPwd !== this.confirmPwd
    },
    canSubmit() {
      return !!(this.pwCode.trim() && this.newPwd && this.confirmPwd && this.pwMatch)
    },
    pwStrength() {
      if (!this.newPwd) return 0
      if (this.newPwd.length < 6) return 1
      if (this.newPwd.length < 10) return 2
      return 3
    },
    strengthColor() {
      return ['', '#E85D5D', '#FA8C16', '#52C41A'][this.pwStrength]
    },
    strengthLabel() {
      return ['', '弱', '中', '强'][this.pwStrength]
    }
  },
  created() {
    this.getUserinfoData({
      data: {},
      success: (res) => {
        if (res.code === 200) {
          this.phone = res.data.mobile || ''
          this.phoneShow = this.phone ? this.phone.substr(0, 3) + '****' + this.phone.substr(7) : '-'
        }
      }
    })
  },
  methods: {
    ...mapActions({
      getUserinfoData: 'login/getUserinfoData',
      getCodeData: 'login/getCodeData',
      doChangePwd: 'ucenter/doChangePwd',
      getGenerateCheckCode: 'ucenter/getGenerateCheckCode'
    }),
    startCountdown() {
      this.pwCountdown = 60
      const timer = setInterval(() => {
        this.pwCountdown -= 1
        if (this.pwCountdown <= 0) clearInterval(timer)
      }, 1000)
    },
    sendPwCode() {
      if (!common._verify_mobile(this.phone)) {
        this.$message.error('绑定手机号异常')
        return
      }
      this.getCodeData({
        data: { mobile: this.phone },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success('发送成功~')
            this.startCountdown()
          } else {
            this.$message.error(res.message || '发送失败')
          }
        }
      })
    },
    changePwd() {
      if (this.pwdSubmitting) return
      this.pwdSubmitting = true
      this.doChangePwd({
        data: { sms_code: this.pwCode, password: this.newPwd, repeat_password: this.confirmPwd },
        success: (res) => {
          this.pwdSubmitting = false
          if (res.code === 200) {
            this.$message.success('修改成功~')
            this.showPwModal = false
            this.pwCode = ''
            this.newPwd = ''
            this.confirmPwd = ''
          } else {
            this.$message.error(res.msg || res.message)
          }
        }
      })
    },
    getAuthCode() {
      if (this.codeLoading) return
      this.codeLoading = true
      this.getGenerateCheckCode({
        data: {},
        success: (res) => {
          this.codeLoading = false
          if (res.code === 200) {
            this.authCode = res.data && res.data.code != null ? String(res.data.code) : ''
            if (!this.authCode) {
              this.$message.error('授权码为空')
              return
            }
            this.copyToClipboard(this.authCode)
            this.$message.success('授权码已复制')
          } else {
            this.$message.error(res.msg || res.message || '获取授权码失败')
          }
        }
      })
    },
    copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).catch(() => { this.copyFallback(text) })
      } else {
        this.copyFallback(text)
      }
      this.copied = true
      setTimeout(() => { this.copied = false }, 2500)
    },
    copyFallback(text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      document.body.removeChild(input)
    },
    downloadZM() {
      window.open('https://xingjiance.oss-cn-hangzhou.aliyuncs.com/wmxx/exe/%E5%BA%97%E9%93%BA%E5%8A%A9%E6%89%8B%E5%AE%89%E8%A3%85%E5%8C%851.2.2.exe', '_blank')
    },
    downloadXinghaohuoOpsPlugin() {
      window.open('https://xinghaohuo.oss-cn-beijing.aliyuncs.com/plugin/%E8%A7%82%E6%98%9F%E6%A0%91%E8%BF%90%E8%90%A5%E6%8F%92%E4%BB%B6.zip', '_blank')
    },
    downloadXinghaohuoSkuPlugin() {
      window.open('https://xinghaohuo.oss-cn-beijing.aliyuncs.com/plugin/%E6%98%9F%E5%A5%BD%E8%B4%A7sku%E6%8F%92%E4%BB%B6.zip', '_blank')
    }
  }
}
</script>

<style scoped>

.gx-profile__tabs {
  display: flex;
  border-bottom: 1px solid #E0E0EC;
  margin-bottom: 20px;
}
.gx-profile__tab {
  padding: 9px 22px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: #4A4A6A;
  background: #FFFFFF;
  border-bottom: 2px solid transparent;
  transition: all .15s;
}
.gx-profile__tab--on {
  color: #C8443C;
  font-weight: 600;
  border-bottom-color: #C8443C;
}
.gx-profile__max {
  max-width: 620px;
}
.gx-profile__avatar-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: #fff;
  border-radius: 8px 8px 0 0;
  border: 2px solid #E0E0EC;
  border-bottom: none;
}
.gx-profile__avatar-wrap {
  position: relative;
}
.gx-profile__avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #D4A946, #E8B950);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Serif SC', serif;
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  border: 3px solid #FFCCC7;
}
.gx-profile__avatar-online {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #52C41A;
  border: 2px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gx-profile__name {
  font-family: 'Noto Serif SC', serif;
  font-size: 16px;
  font-weight: 700;
  color: #1A1A2E;
  margin-bottom: 3px;
}
.gx-profile__badges {
  display: flex;
  gap: 6px;
}
.gx-profile__badge {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
}
.gx-profile__badge--vip {
  background: rgba(212, 169, 70, .1);
  border: 1px solid rgba(212, 169, 70, .3);
  color: #D4A946;
  font-weight: 600;
}
.gx-profile__badge--online {
  background: #F6FFED;
  border: 1px solid #B7EB8F;
  color: #52C41A;
}
.gx-profile__info-card {
  background: #fff;
  border-radius: 0 0 8px 8px;
  border: 2px solid #E0E0EC;
  border-top: none;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .05);
}
.gx-profile__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #E0E0EC;
}
.gx-profile__row-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.gx-profile__row-label {
  font-size: 13px;
  color: #4A4A6A;
  width: 100px;
  flex-shrink: 0;
}
.gx-profile__row-value {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 14px;
  color: #1A1A2E;
}
.gx-profile__mono {
  letter-spacing: .08em;
}
.gx-profile__verified {
  padding: 1px 7px;
  border-radius: 3px;
  background: #E6F4FF;
  border: 1px solid #91CAFF;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 10px;
  color: #1677FF;
}
.gx-profile__btn-red {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 30px;
  padding: 0 14px;
  border-radius: 5px;
  cursor: pointer;
  background: #FFF5F5;
  border: 1px solid #FFCCC7;
  font-size: 12px;
  font-weight: 500;
  color: #C8443C;
  transition: all .18s;
  white-space: nowrap;
}
.gx-profile__btn-red:hover {
  background: #C8443C;
  color: #fff;
}
.gx-profile__btn-red:disabled {
  opacity: .6;
  cursor: not-allowed;
}
.gx-profile__tip {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 12px 20px;
  background: #F5F0E8;
  font-size: 11px;
  color: #6A6A8A;
}
.gx-profile__soft-card {
  background: #fff;
  border-radius: 8px;
  border: 2px solid #E0E0EC;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .05);
}
.gx-profile__banner {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px;
}
.gx-profile__banner--red {
  background: linear-gradient(135deg, #C8443C 0%, #F07575 100%);
}
.gx-profile__banner--blue {
  background: linear-gradient(135deg, #1677FF 0%, #4096ff 100%);
}
.gx-profile__banner-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, .2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  flex-shrink: 0;
}
.gx-profile__banner-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 3px;
}
.gx-profile__banner-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, .8);
}
.gx-profile__soft-body {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.gx-profile__soft-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-radius: 8px;
  background: #F5F0E8;
  border: 2px solid #E0E0EC;
}
.gx-profile__soft-name {
  font-size: 13px;
  font-weight: 500;
  color: #1A1A2E;
  margin-bottom: 3px;
}
.gx-profile__soft-desc {
  font-size: 11px;
  color: #6A6A8A;
}
.gx-profile__soft-sub {
  font-size: 10px;
  color: #6A6A8A;
  margin-top: 2px;
}
.gx-profile__soft-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}
.gx-profile__download {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 18px;
  border-radius: 7px;
  cursor: pointer;
  background: #FFF5F5;
  border: 1.5px solid #FFCCC7;
  font-size: 13px;
  font-weight: 500;
  color: #C8443C;
  transition: all .18s;
  white-space: nowrap;
}
.gx-profile__download:hover {
  background: #fff8f8;
  border-color: #C8443C;
  box-shadow: 0 0 12px rgba(255, 77, 79, .15);
}
.gx-profile__copied {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  color: #52C41A;
}
.gx-profile__notice {
  margin-top: 2px;
  padding: 10px 14px;
  border-radius: 7px;
  background: #E6F4FF;
  border: 1px solid #91CAFF;
  display: flex;
  gap: 8px;
  align-items: flex-start;
}
.gx-profile__notice svg {
  flex-shrink: 0;
  margin-top: 1px;
}
.gx-profile__notice-text {
  font-size: 11px;
  color: #1677FF;
  line-height: 1.65;
}
.gx-profile__modal {
  position: fixed;
  inset: 0;
  z-index: 900;
  background: rgba(0, 0, 0, .42);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-profile__modal-box {
  width: 100%;
  max-width: 440px;
  border-radius: 10px;
  background: #fff;
  border: 2px solid #E0E0EC;
  box-shadow: 0 12px 48px rgba(0, 0, 0, .18);
  overflow: hidden;
}
.gx-profile__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 20px;
  border-bottom: 1px solid #E0E0EC;
  background: #F5F0E8;
}
.gx-profile__modal-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-profile__modal-bar {
  width: 3px;
  height: 15px;
  border-radius: 2px;
  background: #C8443C;
}
.gx-profile__modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-profile__modal-close {
  width: 26px;
  height: 26px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 2px solid #E0E0EC;
  cursor: pointer;
}
.gx-profile__modal-close:hover {
  background: #FFF5F5;
}
.gx-profile__modal-body {
  padding: 20px 20px 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.gx-profile__pw-field {
  position: relative;
}
.gx-profile__pw-label-row {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 8px;
}
.gx-profile__req {
  color: #C8443C;
  font-size: 13px;
}
.gx-profile__pw-label {
  font-size: 11px;
  color: #4A4A6A;
  letter-spacing: .06em;
  text-transform: uppercase;
}
.gx-profile__pw-hint {
  font-size: 10px;
  color: #6A6A8A;
  margin-left: 2px;
}
.gx-profile__pw-code-row {
  display: flex;
  gap: 8px;
}
.gx-profile__pw-input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #E0E0EC;
  border-radius: 6px;
  outline: none;
  font-size: 13px;
  color: #1A1A2E;
  box-sizing: border-box;
  transition: border .15s;
}
.gx-profile__pw-input:focus {
  border-color: #C8443C;
  box-shadow: 0 0 0 2px #FFF5F5;
}
.gx-profile__pw-input--flex {
  flex: 1;
  font-family: 'JetBrains Mono', monospace;
  font-size: 14px;
}
.gx-profile__pw-input--err {
  border-color: #C8443C;
}
.gx-profile__btn-send {
  height: 40px;
  padding: 0 14px;
  border-radius: 6px;
  cursor: pointer;
  background: #C8443C;
  border: 1px solid #C8443C;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  flex-shrink: 0;
  transition: all .2s;
  white-space: nowrap;
  min-width: 100px;
}
.gx-profile__btn-send:disabled {
  background: #FFF5F5;
  border-color: #FFCCC7;
  color: #C8443C;
  cursor: not-allowed;
}
.gx-profile__pw-input-wrap {
  position: relative;
}
.gx-profile__pw-input-wrap .gx-profile__pw-input {
  padding-right: 36px;
}
.gx-profile__pw-eye {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #6A6A8A;
  line-height: 0;
  padding: 0;
}
.gx-profile__pw-eye:hover {
  color: #C8443C;
}
.gx-profile__pw-strength {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}
.gx-profile__pw-bars {
  display: flex;
  gap: 3px;
}
.gx-profile__pw-bar {
  width: 30px;
  height: 3px;
  border-radius: 2px;
  transition: background .2s;
}
.gx-profile__pw-strength-text {
  font-size: 10px;
}
.gx-profile__pw-match {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 5px;
  font-size: 11px;
}
.gx-profile__modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #E0E0EC;
  background: #F5F0E8;
}
.gx-profile__modal-btn {
  height: 32px;
  padding: 0 16px;
  border-radius: 5px;
  cursor: pointer;
  background: #fff;
  border: 2px solid #E0E0EC;
  font-size: 13px;
  color: #4A4A6A;
}
.gx-profile__modal-btn--red {
  background: linear-gradient(135deg, #C8443C, #F07575);
  border: none;
  font-family: 'Noto Serif SC', serif;
  font-weight: 700;
  color: #fff;
}
.gx-profile__modal-btn--red:disabled {
  background: #f0f0f0;
  color: #6A6A8A;
  opacity: .6;
  cursor: not-allowed;
}
</style>
